export const NODE_PROTOCOL_VERSION = 1;
//# sourceMappingURL=node.js.map